<div class="clear"></div>
<section class="banner">
  <div class="container py-4">
    <h1>Contact us</h1>
  </div>
</section>
<div class="class py-3"></div>
<section class="container">
  <div class="d-flex justify-content-between">
    <h4 class="font-weight-semi-bold">Contact us</h4>
    <h5 class="text-black font-weight-medium">
      EPADS UAN: <a href="tel:051111137237" class="text-primary font-weight-bold">051-111-137-237</a><br>
      PPRA Exchange No: <a href="tel:0519205601" class="text-primary font-weight-bold">051-9205601~08</a><br>
      PPRA Main Reception: <a href="tel:860" class="text-primary font-weight-bold">860</a><br>
      Email: <a href="mailto:contact@ppra.org.pk" class="text-primary font-weight-bold">contact@ppra.org.pk</a>
    </h5>




  </div>
  <!-- <p>It is to inform that all the correspondence through following email addresses with PPRA officers be considered as
    an official correspondence, Any official correspondence with PPRA employees on his personal email address shall not
    be considered as official correspondence.</p> -->
  <div class="well bg-light" *ngFor="let item of Section1Array">
    <h5 class="font-weight-medium">{{item.Name}}</h5>
    <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
    <p class="my-2">
      <span class="text-nowrap">
        <i class="fas fa-phone text-success mr-1"></i> {{item.PhoneNumber}}
      </span>
    </p>
    <p class="mb-0">
      <!-- <i class="far fa-envelope text-success mr-1"></i> <a href="mailto:mdppra@ppra.org.pk">{{item.Email}}</a> -->
    </p>
  </div>
  <div class="well pb-0">
    <h5 class="card-title">LEGAL WING</h5>
    <hr>
    <div class="row">
      <div class="col-md-4 border-right mt-4" *ngFor="let item of Section2Array">
        <h6 class="font-weight-medium">{{item.Name}}</h6>
        <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
        <p>
          <i *ngIf="item.PhoneNumber" class="fas fa-phone text-success mr-1"></i>{{item.PhoneNumber}} <br>
          <!-- <i class="far fa-envelope text-success mr-2"></i> <a href="mailto:aslamwaseem@ppra.org.pk">{{item.Email}}</a> -->
        </p>
      </div>
    </div>
  </div>
  <div class="well pb-0">
    <h5 class="card-title">MONITORING & EVALUATION WING</h5>
    <hr>
    <div class="row">
      <div class="col-md-4 border-right border-bottom mt-4" *ngFor="let item of Section3Array">
        <h6 class="font-weight-medium">{{item.Name}}</h6>
        <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
        <p>
          <i *ngIf="item.PhoneNumber" class="fas fa-phone text-success mr-1"></i> {{item.PhoneNumber}}<br>
          <!-- <i class="far fa-envelope text-success mr-2"></i> <a href="mailto:asimjaleel@ppra.org.pk">{{item.Email}}</a> -->
        </p>
      </div>
    </div>
  </div>
  <div class="well pb-0">
    <h5 class="card-title">IT & RESEARCH WING</h5>
    <hr>
    <div class="row">
      <div class="col-md-4 border-right border-bottom mt-4" *ngFor="let item of Section4Array">
        <h6 class="font-weight-medium">{{item.Name}}</h6>
        <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
        <p>
          <i *ngIf="item.PhoneNumber" class="fas fa-phone text-success mr-1"></i> {{item.PhoneNumber}}<br>
          <!-- <i class="far fa-envelope text-success mr-2"></i> <a href="mailto:ateeq@ppra.org.pk">{{item.Email}}</a> -->
        </p>
      </div>
    </div>
  </div>
  <div class="well pb-0">
    <h5 class="card-title">FINANCE WING</h5>
    <hr>
    <div class="row">
      <div class="col-md-4 border-right border-bottom mt-4" *ngFor="let item of Section5Array">
        <h6 class="font-weight-medium">{{item.Name}}</h6>
        <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
        <p>
          <i *ngIf="item.PhoneNumber" class="fas fa-phone text-success mr-1"></i> {{item.PhoneNumber}}<br>
          <!-- <i class="far fa-envelope text-success mr-2"></i> <a href="mailto:aliasghar@ppra.org.pk">{{item.Email}}</a> -->
        </p>
      </div>
    </div>
  </div>
  <div class="well pb-0">
    <h5 class="card-title">HR WING</h5>
    <hr>
    <div class="row">
      <div class="col-md-4 border-right border-bottom mt-4" *ngFor="let item of Section6Array">
        <h6 class="font-weight-medium">{{item.Name}}</h6>
        <p class="text-black-50 font-weight-medium Roboto">{{item.Description}}</p>
        <p>
          <i *ngIf="item.PhoneNumber" class="fas fa-phone text-success mr-1"></i> {{item.PhoneNumber}}<br>
          <!-- <i class="far fa-envelope text-success mr-2"></i> <a href="mailto:farrukh@ppra.org.pk">{{item.Email}}</a> -->
        </p>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <!-- <h5 class="card-title mb-0 font-weight-medium">For tender and evaluation uploading fee/invoice/bill contact at <a
          href="tel:0519203541" class="text-primary font-weight-bold">051-9203541</a></h5> -->
      <h5 class="card-title mb-0 font-weight-medium">
        For tender and evaluation uploading, contact at
        <a href="tel:0519205726" class="text-primary font-weight-bold">051-9205726</a>.
        <br>
        For fee/invoice/bill payment matters, contact at
        <a href="tel:0519203541" class="text-primary font-weight-bold">051-9203541</a>.
      </h5>

    </div>
    <div class="card-body">
      <p>To advertise your tenders/procurement advertisements at PPRA website, Email at <a
          href="mailto:info@ppra.org.pk">info@ppra.org.pk</a> with attachment, or send by post at Following Address:</p>
      <div class="row">
        <div class="col-lg-3">
          <h6 class="font-weight-medium">Mr. Rizwan Mehmood</h6>
          <!-- <p class="text-black-50 font-weight-medium Roboto">Director (MIS)</p> -->
        </div>
        <div class="col-lg-6">
          <div class="media">
            <i class="fas fa-map-marker-alt text-success mt-2 mr-3"></i>
            <div class="media-body">
              Public Procurement Regulatory Authority,<br>1st Floor FBC Building Near State Bank,<br>Sector G-5/2,
              Islamabad-Pakistan
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="media">
            <i class="fas fa-phone text-success mt-2 mr-3"></i>
            <div class="media-body">
              92-51-920-57-28<br>92-51-920-57-26<br>92-51-921-91-49
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3318.4408223337373!2d73.0939720752114!3d33.72341543502259!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfc07c7d907aa5%3A0xccce2da1a9319462!2sPublic%20Procurement%20Regulatory%20Authority!5e0!3m2!1sen!2s!4v1709213250129!5m2!1sen!2s"
    width="100%" height="500" class="bg-white border p-1" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade"></iframe>
  <p class="mt-3">Send mail to <a href="mailto:info@ppra.org.pk">info@ppra.org.pk</a> with questions or comments about
    this web site.</p>
</section>
<div class="class py-3"></div>